import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router';
import { Layout } from './components/Layout';
import { useAuth } from './lib/auth';
import { AfterPage } from './pages/AfterPage';
import { HomePage } from './pages/HomePage';
import { JoinPage } from './pages/JoinPage';
import { ListsPage } from './pages/ListsPage';
import { LoginPage } from './pages/LoginPage';
import { NewListPage } from './pages/NewListPage';
import { ArticlePage, ProductPage } from './pages/PriceHistoryPage';
import { PricesPage } from './pages/PricesPage';
import { ReceiptPage } from './pages/ReceiptPage';
import { SharePage } from './pages/SharePage';
import { ShopPage } from './pages/ShopPage';
import { StoresPage } from './pages/StoresPage';
import { UpdatePrompt } from './components/UpdatePrompt';
import { ErrorBoundary } from './components/ErrorBoundary';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === 'loading') return <div className="p-8 text-center text-stone-500">Ładowanie…</div>;
  if (auth.status === 'anonymous') {
    // Udostępniony tekst przechowujemy, żeby po zalogowaniu wrócić do niego.
    const next = location.pathname + location.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <UpdatePrompt />
      <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<ListsPage />} />
          <Route path="new" element={<NewListPage />} />
          <Route path="share" element={<SharePage />} />
          <Route path="stores" element={<StoresPage />} />
          <Route path="home" element={<HomePage />} />
          <Route path="prices" element={<PricesPage />} />
          <Route path="receipts/:id" element={<ReceiptPage />} />
          <Route path="products/:id" element={<ProductPage />} />
          <Route path="articles/:id" element={<ArticlePage />} />
          <Route path="join" element={<JoinPage />} />
          <Route path="lists/:id" element={<ShopPage />} />
          <Route path="lists/:id/after" element={<AfterPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
